module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"row\">\n	<div style=\"margin-bottom: 6px\">Показать слои:</div>\n	<div>\n		<label><input type=\"checkbox\" on-click=\"onToggleRouteClick\" name=\"route-segment-toggler\" value=\"signalPoints\"/>&nbsp;точки сигналов\n			<span style=\"color: green\">&FilledSmallSquare;</span></label>\n	</div>\n	<div>\n		<label><input type=\"checkbox\" on-click=\"onToggleRouteClick\" name=\"route-segment-toggler\" value=\"normal\" checked=\"checked\"/>&nbsp;нормальные\n			участки\n			<span style=\"color: blue\">&FilledSmallSquare;</span></label>\n	</div>\n	<div>\n		<label><input type=\"checkbox\" on-click=\"onToggleRouteClick\" name=\"route-segment-toggler\" value=\"megaSpeed\" checked=\"checked\"/>&nbsp;участки\n			мега-скоростей\n			<span style=\"color: yellow\">&FilledSmallSquare;</span></label>\n	</div>\n	<div>\n		<label><input type=\"checkbox\" on-click=\"onToggleRouteClick\" name=\"route-segment-toggler\" value=\"jump\" checked=\"checked\"/>&nbsp;прыжки\n			<span style=\"color: orange\">&FilledSmallSquare;</span></label>\n	</div>\n	<div>\n		<label><input type=\"checkbox\" on-click=\"onToggleRouteClick\" name=\"route-segment-toggler\" value=\"noSignals\" checked=\"checked\"/>&nbsp;участки\n			отсутствия сигналов\n			<span style=\"color: red\">&FilledSmallSquare;</span></label>\n	</div>\n</div>")
  }
  return __output.join("");

}